import { Route, Switch, Redirect } from "react-router-dom";
import { HomeMobilePage } from "@pages/Home/mobile/HomeMobilePage";
import { ROUTES } from "@constants";
import { ConfirmationPage } from "@pages/Confirmation/ConfirmationPage";
import { StepperPage } from "@pages/Stepper/StepperPage";
import { HomeBroadbandPage } from "@pages/Home/broadband/HomeBroadbandPage";
import { HomeBroadbandResultPage } from "@pages/Home/broadband/HomeBroadbandResultPage";
import { BroadbandLoginPage } from "@pages/BroadbandLogin/BroadbandLoginPage";

export const Routes = () => {
    return (
        <Switch>
            <Route exact path={ROUTES.BASE_URL}>
                <Redirect to={ROUTES.MOBILE_PAGE_URL} />
            </Route>
            <Route exact path={ROUTES.MOBILE_PAGE_URL}>
                <HomeMobilePage />
            </Route>
            <Route exact path={ROUTES.BROADBAND_PAGE_URL}>
                <HomeBroadbandPage />
            </Route>
            <Route exact path={ROUTES.BROADBAND_RESULT_PAGE_URL}>
                <HomeBroadbandResultPage />
            </Route>
            <Route exact path={ROUTES.BROADBAND_LOGIN_PAGE_URL}>
                <BroadbandLoginPage />
            </Route>
            <Route exact path={ROUTES.CONFIRMATION_PAGE_URL}>
                <ConfirmationPage />
            </Route>
            <Route path={ROUTES.BASE_URL}>
                <StepperPage />
            </Route>
        </Switch>
    );
};
